export default __webpack_public_path__ + "static/media/cheese.6ea8d347.png";